// 更新公用枚举值
export function updateEnumConf(state, payload) {
  state.enumConf = payload
}

// 更新广告配置
export function updateAdConf(state, payload) {
  state.adConf = payload
}
